import Vue from '../helpers/VueBase';
import Snackbar from './Snackbar.vue';

new Vue({
  render: h => h(Snackbar),
}).$mount('.snackbar-vue');
